import { get } from 'lodash';
import { AUTH_ACTIONS } from 'store/v1/auth/auth.constants.js';
import { PUBLIC_SETTINGS_ACTIONS } from 'store/v1/public_settings/public_settings.constants.js';
import { SHORTLISTS_ACTIONS } from 'store/v1/shortlists/shortlists.constants.js';
import { CALLOUT_ACTIONS } from 'store/v1/callouts/callouts.constants.js';

export const INITIAL_STATE = {
  core_fields_pronouns_options: [],
  pronouns_enabled_resource_type_ids: [],
  source: null
};

function normalizePronounsOptions(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map(option => ({
      id: Number(option?.id),
      value: String(option?.value || '').trim(),
      order:
        option?.order == null || option?.order === ''
          ? null
          : Number(option.order)
    }))
    .filter(option => Number.isInteger(option.id) && option.value.length > 0);
}

function getPronounsOptionsFromPublicPayload(action) {
  return (
    get(action, 'result.global_settings.core_fields_pronouns_options') ||
    get(action, 'global_settings.core_fields_pronouns_options') ||
    get(action, 'payload.global_settings.core_fields_pronouns_options') ||
    get(action, 'payload.core_fields_pronouns_options')
  );
}

function normalizeResourceTypeIds(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map(id => Number(id)).filter(id => Number.isInteger(id));
}

function getPronounsEnabledResourceTypeIdsFromPublicPayload(action) {
  return (
    get(action, 'result.global_settings.pronouns_enabled_resource_type_ids') ||
    get(action, 'global_settings.pronouns_enabled_resource_type_ids') ||
    get(action, 'payload.global_settings.pronouns_enabled_resource_type_ids')
  );
}

function getPronounsEnabledResourceTypeIdsFromAuthPayload(action) {
  const resourceTypes = get(action, 'result.resource_types', []);
  if (!Array.isArray(resourceTypes)) return [];
  return resourceTypes
    .filter(resourceType => {
      const fields = get(resourceType, 'metastructure.fields', []);
      return (
        Array.isArray(fields) &&
        fields.some(field => field?.name === 'pronouns' && field?.active)
      );
    })
    .map(resourceType => Number(resourceType.id))
    .filter(id => Number.isInteger(id));
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_ACTIONS.LOAD_AUTH_SUCCESS:
      return {
        ...state,
        core_fields_pronouns_options: normalizePronounsOptions(
          get(action, 'result.core_fields_pronouns_options')
        ),
        pronouns_enabled_resource_type_ids:
          getPronounsEnabledResourceTypeIdsFromAuthPayload(action),
        source: 'auth'
      };
    case AUTH_ACTIONS.LOAD_AUTH_FAILURE:
      return {
        ...INITIAL_STATE
      };
    case AUTH_ACTIONS.UPDATE_SETTINGS_SUCCESS:
      if (action.field_key !== 'core_fields_pronouns_options') return state;
      return {
        ...state,
        core_fields_pronouns_options: normalizePronounsOptions(action.result),
        source: 'auth'
      };
    case PUBLIC_SETTINGS_ACTIONS.GET_PUBLIC_SETTINGS_SUCCESS:
    case SHORTLISTS_ACTIONS.GET_PUBLIC_SHORTLIST_SUCCESS:
    case CALLOUT_ACTIONS.GET_PUBLIC_CALLOUT_SUCCESS:
    case 'PUBLIC_SETTINGS_READY': {
      if (state.source === 'auth') return state;
      const publicPronounsOptions = getPronounsOptionsFromPublicPayload(action);
      const publicPronounsEnabledResourceTypeIds =
        getPronounsEnabledResourceTypeIdsFromPublicPayload(action);
      if (
        publicPronounsOptions == null &&
        publicPronounsEnabledResourceTypeIds == null
      ) {
        return state;
      }
      return {
        ...state,
        core_fields_pronouns_options:
          publicPronounsOptions == null
            ? state.core_fields_pronouns_options
            : normalizePronounsOptions(publicPronounsOptions),
        pronouns_enabled_resource_type_ids:
          publicPronounsEnabledResourceTypeIds == null
            ? state.pronouns_enabled_resource_type_ids
            : normalizeResourceTypeIds(publicPronounsEnabledResourceTypeIds),
        source: 'public'
      };
    }
    default:
      return state;
  }
}
